
import { alert } from "./sweetAlert";

export const previewValidators = (selectedFinancialYear, selectedQuarter, HalfYearly, selectedHalfYearly, dispatch, pmsName) => {

  if (HalfYearly) {

    if (selectedFinancialYear === "" && selectedHalfYearly === "" && pmsName.length == 0) {
      alert("Please fill in all the details", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    }
    else if(pmsName.length == 0){
      alert("Please Select PMS", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    } 
    else if (selectedFinancialYear === "") {
      alert("Please Select Financial Year", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    }  else {
      //API call condition satisfied
      return true;
    }

  } else {
    if (selectedFinancialYear === "" && selectedQuarter === "" && pmsName.length == 0) {
      alert("Please fill in all the details", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    } else if(pmsName.length == 0){
      alert("Please Select PMS", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    } else if (selectedFinancialYear === "") {
      alert("Please Select Financial Year", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    } else if (selectedQuarter === "") {
      alert("Please Select Quarter", "", "warning")
      dispatch({ type: "HIDE_LOADER" });
      return false;
    } else {
      //API call condition satisfied
      return true;
    }
  }
}